export default state => state.category.serverError;
